module.exports = __webpack_public_path__ + "static/media/login.3888daa9.jpeg";